/* Funcao padrao para gerar datas no app */

import moment from 'moment-timezone';

const libutil = {
  bloqueiaSpam: {
    ultimoValor: {},
    idTimer: null,
  },
};

// Função padrão para gerar datas no app.
export function geraData(date = new Date(), mascara = 'YYYY-MM-DD HH:mm:ss.SSS', timezone = 'America/Sao_Paulo') {
  return moment(date).tz(timezone).format(mascara);
}

// Função de Throttling para uso em campos primitivos.
export async function bloqueiaSpam(valor, tempoMinimo = 1) {
  if (libutil.bloqueiaSpam.ultimoValor !== valor) {
    console.log('acaoLiberada');
    libutil.bloqueiaSpam.ultimoValor = valor;

    clearTimeout(libutil.bloqueiaSpam.idTimer);

    libutil.bloqueiaSpam.idTimer = setTimeout(() => {
      libutil.bloqueiaSpam.ultimoValor = {};
    }, tempoMinimo * 1000);

    return false;
  }
  console.log('acaoBloqueada');
  return true;
}
